<app-nav></app-nav>
<section class="personalAccident">
  <div class="container">
    <app-click-to-call></app-click-to-call>
    <div class="col">
      <form name="form" (ngSubmit)="f.form.valid"  #f="ngForm">
        <center class="top-gap-sm">
          <img src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/doctor-PI/doctor-main.png" class="img-responsive">
        </center>
        <center class="sub-title">
          <p>Save 60% cost</p>
        </center>
        <div class="col sum-container">
          <p class="title">Select your Specialization</p>
          <div class="sum-insured-input">
            <div class="form-group">
                <select class="form-control" name="specialization" id="specialization" [(ngModel)]="specialization" (change)="selectedSpecialization();" required>
                  <option value="Anesthetist">Anesthetist</option>
                  <option value="Dentist">Dentist</option>
                  <option value="Cosmetic Surgeons">Cosmetic Surgeons</option>
                  <option value="Eye Specialist">Eye Specialist</option>
                  <option value="General Physician">General Physician</option>
                  <option value="Lithotripsy">Lithotripsy</option>
                  <option value="Maxillo Facial Surgeon/Dermatologist">Maxillo Facial Surgeon/Dermatologist</option>
                  <option value="Non Surgeons">Non Surgeons</option>
                  <option value="Obstetrician">Obstetrician</option>
                  <option value="Pathologist">Pathologist</option>
                  <option value="Plastic Surgeon">Plastic Surgeon</option>
                  <option value="Radiologist">Radiologist</option>
                  <option value="Specialist/Consultants">Specialist/Consultants</option>
                  <option value="Surgeons">Surgeons</option>
                </select>
              </div>
          </div>
          <section *ngIf="this.subOptions.length > 0">
          <p class="title">Select your Sub-Specialization</p>
          <div class="sum-insured-input">
            <div class="form-group">
                <select class="form-control" name="subOptions" id="subOptions" [(ngModel)]="subOptionsvalue" (change)="selectSubOptions();" required>
                  <option *ngFor="let oneOption of subOptions" [ngValue]="oneOption">{{oneOption}}</option>
                </select>
              </div>
          </div>
        </section>
          <div class="text-center top-gap-lg">
            <button class="btn btn-bordered-blue" [disabled]="f.form.invalid" (click)="createProspect(true)">Next</button>
          </div>
        </div>
      </form>
      <div class="col text-center top-gap-sm mb-5">
        <h6 _ngcontent-unn-c5="" class="mt-2 text-center" style="
        text-align: center!important;
        margin: 0 auto;
        margin-bottom: 15px;font-weight: 600;
    ">INSURERS</h6>
        <div class="row insurer-logo">
          <div class="col">
            <img src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/insurer/united-india-logo.png">
          </div>
          <div class="col">
            <img src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/insurer/future-generali.png">
          </div>
          <div class="col top-gap-sm">
            <img src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/insurer/iciciLombard.webp">
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="footer-bar">
    <span><b><u>Fill Info</u></b></span><span class="next-step-icon"></span><span>Quote Page</span>
  </div>
  <div id="spinner" [hidden]="!loading">
      <div class="spinnerfull">
          <i class="fa fa-spinner fa-spin fa-3x"></i>
      </div>
  </div>
</section>